"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _uiPropTypes = require("@instructure/ui-prop-types");

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _isActiveElement = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/isActiveElement"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _SelectField = _interopRequireDefault(require("../SelectField"));

var _getOptionId = _interopRequireDefault(require("../utils/getOptionId"));

var _dec, _class, _class2, _temp;

var optionType = _propTypes.default.shape({
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired,
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  children: _propTypes.default.node
});
/**
---
parent: Select
---
**/


var SelectSingle = (_dec = (0, _uiTestable.default)(), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SelectSingle, _Component);

  function SelectSingle(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, SelectSingle);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SelectSingle).call(this, _props));
    _this._input = null;

    _this.focus = function () {
      _this._input && _this._input.focus();
    };

    _this.matchSelectedOption = function (state, selectedOption) {
      var inputValue = _this._input.value;
      var match;

      if (selectedOption) {
        // find option with a value that matches current selected value
        match = state.filteredOptions.find(function (option) {
          return option.value === selectedOption.value;
        });
      } else {
        // find option with a label that matches input's value
        match = state.filteredOptions.find(function (option) {
          return option.label.toLowerCase() === inputValue.toLowerCase();
        });
      }

      return match;
    };

    _this.handleClose = function (event, newSelectedOption) {
      return _this.setState(function (prevState, props) {
        var inputValue = _this._input.value;

        var match = _this.matchSelectedOption(prevState, newSelectedOption);

        var selectedOption = newSelectedOption || prevState.selectedOption;

        if (match) {
          _this._input.value = match.label;

          if (!selectedOption || (0, _getOptionId.default)(match) !== (0, _getOptionId.default)(selectedOption)) {
            props.onChange(event, match);
          }
        } else if (selectedOption) {
          if (props.allowEmpty && _this._input.value === '') {
            props.onChange(event, null);
            return {
              filterText: null,
              filteredOptions: props.options,
              selectedOption: null
            };
          } else if (!_this.props.allowCustom) {
            // reset the value to the last valid value
            _this._input.value = selectedOption.label;
          }
        } else if (!_this.props.allowCustom) {
          // clean wrong values
          _this._input.value = '';
        }

        if (_this._input.value !== inputValue) {
          _this.props.onInputChange(null, _this._input.value);
        }

        return {
          filterText: _this.props.allowCustom ? _this._input.value : null,
          filteredOptions: props.options,
          selectedOption: match || selectedOption
        };
      }, _this.props.onClose);
    };

    _this.handleInputChange = function (event, value) {
      _this.props.onInputChange(event, value);

      var filterText = value.toLowerCase();

      if (_this.state.filterText !== filterText) {
        _this.setState(function (prevState, props) {
          var filteredOptions = props.filter(_this.props.options, filterText || '');
          var selectedOption = prevState.selectedOption;

          if (props.allowCustom && filteredOptions.length === 0) {
            selectedOption = void 0;
          }

          return {
            filterText: filterText,
            filteredOptions: filteredOptions,
            selectedOption: selectedOption
          };
        });
      }
    };

    _this.handleSelect = function (event, selectedOption) {
      if (_this._input.value !== selectedOption.label) {
        _this._input.value = selectedOption.label;

        _this.props.onInputChange(null, _this._input.value);
      }

      _this.setState({
        filterText: null,
        filteredOptions: _this.props.options,
        selectedOption: selectedOption
      }, function () {
        return _this.focus();
      });

      _this.props.onChange(event, selectedOption);
    };

    _this.handleInputRef = function (node) {
      _this._input = node;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      _this.props.inputRef.apply((0, _assertThisInitialized2.default)(_this), [node].concat(args));
    };

    _this.state = {
      filterText: null,
      filteredOptions: _props.options,
      selectedOption: _this.getSelectedOptionFromProps(_props)
    };
    return _this;
  }

  (0, _createClass2.default)(SelectSingle, [{
    key: "findSelectedOption",
    value: function findSelectedOption(options, selected) {
      var id = (0, _getOptionId.default)(selected);
      var foundOption = options.find(function (option) {
        return (0, _getOptionId.default)(option) === id;
      });
      return foundOption || selected;
    }
  }, {
    key: "getSelectedOptionFromProps",
    value: function getSelectedOptionFromProps(props, selected) {
      return selected ? this.findSelectedOption(props.options, selected) : this.findSelectedOption(props.options, props.selectedOption || props.defaultSelectedOption);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.selectedOption) {
        this._input.value = this.state.selectedOption.label || '';
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var optionsChanged = !(0, _deepEqual.default)(this.props.options, nextProps.options);
      var selectedChanged = this.props.selectedOption != nextProps.selectedOption // undefined == null -> no change
      && !(0, _deepEqual.default)(this.props.selectedOption, nextProps.selectedOption) && !this.props.disabled && !this.props.readOnly;
      var valueChanged = this.props.value !== nextProps.value;

      if (optionsChanged || selectedChanged || valueChanged) {
        this.setState(function (prevState) {
          var selected = selectedChanged ? null : prevState.selectedOption;

          var selectedOption = _this2.getSelectedOptionFromProps(nextProps, selected);

          var filterText = prevState.filterText || '';

          if (nextProps.allowCustom && selectedChanged && !_this2.props.selectedOption) {
            // went from custom text entry to a selection from the options
            filterText = selectedOption && selectedOption.label || '';
          }

          var filteredOptions = nextProps.filter(nextProps.options, filterText);
          var value = selectedOption && selectedOption.label || nextProps.value || '';

          if ((nextProps.allowCustom || prevState.filterText === null) && _this2._input.value !== value) {
            _this2._input.value = value;
            nextProps.onInputChange(null, _this2._input.value);
          }

          if (optionsChanged) {
            nextProps.onOptionsChange(filteredOptions);
          }

          return {
            selectedOption: selectedOption,
            filteredOptions: filteredOptions
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_SelectField.default, Object.assign({}, (0, _passthroughProps.omitProps)(this.props, SelectSingle.propTypes), {
        editable: this.props.allowCustom || this.props.editable // allowCustom requires editable
        ,
        inputRef: this.handleInputRef,
        options: this.state.filteredOptions,
        selectedOption: this.state.selectedOption,
        disabled: this.props.disabled,
        readOnly: this.props.readOnly,
        onSelect: this.handleSelect,
        onStaticClick: this.focus,
        onClose: this.handleClose,
        onInputChange: this.handleInputChange,
        optionsMaxWidth: this.props.optionsMaxWidth,
        closeOnSelect: this.props.closeOnSelect
      }));
    }
  }, {
    key: "focused",
    get: function get() {
      return (0, _isActiveElement.default)(this._input);
    }
  }, {
    key: "value",
    get: function get() {
      var selected = this.state.selectedOption;

      if (selected) {
        return selected.value;
      }

      if (this.props.allowCustom) {
        return this._input.value;
      }

      return null;
    }
  }]);
  SelectSingle.displayName = "SelectSingle";
  return SelectSingle;
}(_react.Component), _class2.propTypes = {
  /**
  * The options to render in the menu
  */
  options: _propTypes.default.arrayOf(optionType),

  /**
  * a function that provides a reference to the internal input element
  */
  inputRef: _propTypes.default.func,

  /**
  * the selected value (must be accompanied by an `onChange` prop)
  */
  selectedOption: (0, _uiPropTypes.controllable)(_propTypes.default.oneOfType([_propTypes.default.string, optionType]), 'onChange', 'defaultSelectedOption'),

  /**
   * Options dropdown can be wider than input if optionsMaxWidth is provided
   */
  optionsMaxWidth: _propTypes.default.string,

  /**
  * value to set on initial render, meant for an uncontrolled component
  */
  defaultSelectedOption: _propTypes.default.oneOfType([_propTypes.default.string, optionType]),

  /**
  * Determines whether the user can type in the input
  */
  editable: _propTypes.default.bool,

  /**
  * for non-multiple Select, allows the user to empty selection
  */
  allowEmpty: _propTypes.default.bool,

  /**
   * If true, the user can freely enter a value not available in the options list.
   * Implies editable is true.
   */
  allowCustom: _propTypes.default.bool,

  /**
   * Whether or not to disable the input
   */
  disabled: _propTypes.default.bool,

  /**
   * Works just like disabled but keeps the same styles as if it were active
   */
  readOnly: _propTypes.default.bool,

  /**
   * The filter function applied to the options when writing on the input
   */
  filter: _propTypes.default.func,

  /**
   * Callback fired when the menu is closed
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when one of the menu options gets selected
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when on the onChange of the internal input
   */
  onInputChange: _propTypes.default.func,

  /**
   * Callback fired when the options displayed in the menu change
   */
  onOptionsChange: _propTypes.default.func,

  /**
  * should the menu be closed when a selection happens
  */
  closeOnSelect: _propTypes.default.bool,

  /**
   * the current value. The selected option's value, or the entered text if allowCustom is true
   */
  value: _propTypes.default.string
}, _class2.defaultProps = {
  options: void 0,
  selectedOption: void 0,
  defaultSelectedOption: void 0,
  value: void 0,
  filter: void 0,
  readOnly: false,
  disabled: false,
  allowCustom: false,
  allowEmpty: false,
  editable: false,
  optionsMaxWidth: void 0,
  inputRef: function inputRef(node) {},
  onClose: function onClose() {},
  onChange: function onChange(event, selectedOption) {},
  onInputChange: function onInputChange(event, value) {},
  onOptionsChange: function onOptionsChange(filteredOptions) {},
  closeOnSelect: true
}, _temp)) || _class);
var _default = SelectSingle;
exports.default = _default;